<div class="si-health-insurance-selector">
  <ng-container *ngIf="multipleInsuranceAvailable">
    <si-label text="{{text | translate}}"
              tooltipIcon="icosun-help_circle"
              tooltipText="{{tooltipText | translate}}"
              tooltipPosition="right"
              [disabled]="disabled"
    ></si-label>
    <div class="si-radio-button-container_horizontal">
      <si-radio-button id="radioInsurance"
                       name="radioInsurance"
                       text="SI_YES"
                       [(model)]="privateInsurance"
                       (modelChange)="onChangeRadioButtonModel()"
                       [value]="false"
                       [checked]="true"
                       [disabled]="disabled"
      ></si-radio-button>
      <si-radio-button id="radioPrivate"
                       name="radioPrivate"
                       text="SI_NO"
                       [(model)]="privateInsurance"
                       (modelChange)="onChangeRadioButtonModel()"
                       [value]="true"
                       [disabled]="disabled"
      ></si-radio-button>
    </div>
  </ng-container>
  <div [hidden]="privateInsurance" class="mt-3">
    <si-selector id="appoCollective"
                 name="appoCollective"
                 placeholder="SI_SELECT_PLACEHOLDER"
                 [(model)]="collective"
                 (modelChange)="onChangeSelectorModel()"
                 path="/api/v1/insurance?allInsurances={{allInsurances}}&isPrivate={{privateInsurance}}"
                 [showClear]="false"
                 [hideLabel]="true"
                 [getOptionsOnOpen]="true"
                 [selectDefault]="true"
                 (selectDefaultChange)="selectDefaultLoaded($event)"
                 [selectSingle]="privateInsurance"
                 (onOptionsLoaded)="onLoadedOptions($event)"
                 [disabled]="disabled"
                 rule="generic.fieldNotNull">
      <ng-template #item let-item>
        <div [class.bold]="item.value.current">
          <span>{{item.label}}</span>
        </div>
      </ng-template>
    </si-selector>
  </div>
  <div *ngIf="showButton && multipleInsuranceAvailable && !privateInsurance" class="mt-3">
    <si-health-insurance-add-button [openDialogButton]="showButton"
                                    [openDialogButtonDisabled]="disabled"
                                    (onSucessAddInsurance)="onSucessAddInsurance($event)"
    ></si-health-insurance-add-button>
  </div>
</div>
